import React, { useEffect, useState } from "react";
import { Timeline } from "antd";
import moment from "moment";
import "../../styles/features/ChangeLog/ChangeLong.css";
import { getPikaById } from "./data";
const ActivityItem = ({ changeLog }) => {
  //need to change that if teh ngjarje is in proccesing ,do the done icon
  const [pika, setPika] = useState([]);
  useEffect(() => {
    getPikaById(changeLog.ID).then(response => {
      setPika(response);
    });
  }, [changeLog]);
  console.log(changeLog);
  return (
    <Timeline.Item className="TimelineItem">
      <h4 className="gx-text-truncate">{changeLog.Struktura.Emri}</h4>
      <p className="gx-fs-sm">{moment(changeLog.DataOra).format("HH:mm")}</p>
      <ul>
        {pika.map((log, index) => (
          <li key={index} className="gx-fs-sm gx-text-grey">
            {log.type !== undefined ? (
              <span className="gx-badge gx-mb-1 gx-text-white gx-badge-red">
                {log.type}
              </span>
            ) : null}{" "}
            {log.pika}
          </li>
        ))}
      </ul>
    </Timeline.Item>
  );
};

export default ActivityItem;
